import React, { Component } from "react";
import { Card, CardBody, CardGroup, Col, Container, Row } from "reactstrap";
import { connectedLoginForm as LoginForm } from "./LoginForm";
import { BackgroundImageComponentConnected } from "../components/BackgroundImageComponent";
import { LogoComponentConnected } from "../components/LogoComponent";
import { LogoFooterComponentConnected } from "../components/LogoFooterComponent";
import { LogoCardComponentConnected } from "../components/LogoCardComponent";
import { Translate } from "react-i18nify";
import { REACT_DASHBOARD_CLIENT } from "../../config/constant/base";
import { SelectorLanguge } from "../components/SelectorLanguge";
import { langContext } from "../../context/langContext";

export class Login extends Component {
  static contextType = langContext
  isRedeban = () => {
    return REACT_DASHBOARD_CLIENT && REACT_DASHBOARD_CLIENT === "redeban";
  };
  isVicomm = () => {
    return REACT_DASHBOARD_CLIENT && REACT_DASHBOARD_CLIENT === "gpvicomm";
  }


  leftCard = () => {
    if (this.isRedeban()) {
      return <LogoCardComponentConnected />;
    }
    return (
      <Card className="py-5">
        <CardBody className="full-centering">
          <LoginForm />
        </CardBody>
      </Card>
    );
  };

  textRigth = () => {
    if (this.isVicomm()) {
      return (
        <div className="px-4">
          <h4>
            <Translate value="welcome_to_vicomm"/>
          </h4>
          <div className="callout callout-over">
            <h5><Translate value="subtitle_to_vicomm"/></h5>
          </div>
          <div className="callout callout-over">
            <Translate value="login_message_vicomm.1"/>
          </div>
          <div className="callout callout-over">
            <Translate value="login_message_vicomm.2"/>
          </div>
        </div>
      );
    }
    return (
      <div className="px-4">
        <h4>
          <Translate value="welcome_to"/>
        </h4>
        <div className="callout callout-over">
          <Translate value="login_message.1"/>
        </div>
        <div className="callout callout-over">
          <Translate value="login_message.2"/>
        </div>
        <div className="callout callout-over">
          <Translate value="login_message.3"/>
        </div>
      </div>
    )
  }

  rightCard = () => {
    if (this.isRedeban()) {
      return <LoginForm/>;
    }
    return (
      this.textRigth()
    );
  };

  render() {
    const language= this.context
    return (
      <>
        <BackgroundImageComponentConnected type="login" />
        <div className="app flex-row align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col md="9">
                <Row className="justify-content-end"  >
                  <div style={{zIndex:"1", marginTop:"100px"}}  className="login__logo-padding">
                    <SelectorLanguge lang={language}/>
                  </div>
                </Row>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="4" style={{ textAlign: "center" }}>
                <LogoComponentConnected
                  style={{ maxWidth: this.isRedeban() ? "80%" : "100%" }}
                />
              </Col>
            </Row>
            <div style={{ height: "20px" }}></div>
            <Row className="justify-content-center">
              <Col md="9">
                <CardGroup>
                  {this.leftCard()}
                  <Card
                    className={
                      this.isRedeban()
                        ? "text-white py-5 "
                        : "text-white bg-secondary py-5 d-md-down-none"
                    }
                  >
                    <CardBody className="full-centering">
                      {this.rightCard()}
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
            <div style={{ height: "20px" }}></div>
            <LogoFooterComponentConnected />
          </Container>
        </div>
      </>
    );
  }
}

export default Login;
